<template>
  <solleciti />
</template>

<script>
import Solleciti from '@/components/ask/pages/Solleciti.vue'


export default {
  name: 'SollecitiAll',

  components:{
    Solleciti
  },

  data(){
    return {
    
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods:{

  },
}
</script>

<style>

</style>
